<template>
  <div class="row section-row">
    <div class="col-lg-12 row-background-color">
      <div class="row table-head-row-background-color non-mobile-admin-table">
        <div style="width: 20%">Username</div>
        <div style="width: 25%">E-mail</div>
        <div style="width: 20%">Date Added</div>
        <div style="width: 15%">User Role</div>
        <div style="width: 10%">Edit</div>
        <div style="width: 10%">Delete</div>
      </div>


      <div class="row table-head-row-background-color mobile-admin-table">
        <div style="width: 20%">Username</div>
        <div style="width: 30%">E-mail</div>
        <div style="width: 20%">User Role</div>
        <div style="width: 15%">Edit</div>
        <div style="width: 15%">Delete</div>
      </div>

      <div v-if="this.reports.length">
        <div v-for="report in reports.slice(this.queryStart, this.queryEnd)" :key="report.Id">
          <AdministrationRow v-bind:row="report" @changedSelect="selectedRow" @deleteSelect="deletedRow" />
        </div>
      </div>

      <TableMenu v-bind:reports="this.reports" @changedSelect="changePageSelection" />
    </div>
  </div>
</template>

<script>
import AdministrationRow from "./AdministrationRow";
import TableMenu from "./TableMenu.vue";
export default {
  name: "AdministrationTable",
  props: ["reports"],
  components: {
    AdministrationRow,
    TableMenu,
  },
  data() {
    return {
      name: "AdministrationTable",
      queryStart: 0,
      queryEnd: 10,
    };
  },
  methods: {
    selectedRow: function (value) {
      this.$emit("changedSelect", value);
    },
    deletedRow: function (value) {
      this.$emit("deletedSelect", value);
    },
    changePageSelection: function (value) {
      this.queryStart = value.start;
      this.queryEnd = value.end;
    },
  },

  //create computer method called stringAbr tha takes 

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>